module.exports = __webpack_public_path__ + "static/media/hw_ri_40.439fed81.flv";